import classNames from '@/utils/className';
import { ReactNode } from 'react';

export const PlaylistCardList = ({ children, paddingOnTop = false }: { children: ReactNode | ReactNode[]; paddingOnTop?: boolean }) => {
  const variants = {
    paddingOnTop: { true: 'pt-10', false: '' },
  };
  return (
    <div
      className={classNames(
        'grid grid-cols-[repeat(auto-fill,minmax(250px,1fr))] grid-rows-1 gap-5 [grid-auto-columns:1fr]',
        variants.paddingOnTop[paddingOnTop.toString()]
      )}>
      {children}
    </div>
  );
};

export default { PlaylistCardList };
